import { useState, useMemo } from "react";
import { formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";

export default function CircleCalculator() {
  const [r, setR] = useState("10");

  const { area, circumference, diameter } = useMemo(() => {
    const R = Number(r) || 0;
    return { area: Math.PI * R * R, circumference: 2 * Math.PI * R, diameter: 2 * R };
  }, [r]);

  const rows = [
    ["Radius", formatNumber(Number(r) || 0)],
    ["Diameter", formatNumber(diameter)],
    ["Area", `${formatNumber(area)} sq units`],
    ["Circumference", formatNumber(circumference)],
  ];

  return (
    <div>
      <CalcPageHeader title="Circle Calculator" description="Area, circumference and diameter from radius." slug="circle" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6">
            <Field label="Radius" hint="Enter radius in any length unit; results carry the same unit.">
              <input data-testid="circle-radius-input" type="number" value={r} onChange={(e)=>setR(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" />
            </Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Circle" slug="circle" highlight={{ label: "Area", value: formatNumber(area), sub: "square units" }} rows={rows} onReset={()=>setR("")} />
        </div>
      </div>
    </div>
  );
}
